import axiosInstance from '../../utils/axios';


export interface TagSubmissionHistoryItem {
  id: number;
  remoteObjectId: string;
  type: string;
  subtype: string | null;
  status: string;
  orderNumber: string;
  clientName: string | null;
  deliveryAddrStreet: string;
  deliveryAddrCity: string;
  deliveryAddrState: string;
  deliveryAddrPostalCode: string;
  deliveryAddrCountry: string;
  lastModifiedDate: string;
}

export const tagSubmissionHistoryService = {
  getHistoricTagSubmissions: async (): Promise<TagSubmissionHistoryItem[]> => {
    const response = await axiosInstance.get('/api/v1/tasks/historic-tag-submissions');
    return response.data;
  }
};
